import axios from 'axios';
import { api_url, mg_token_name } from '../config/Params.constant';
import storage from './Storage';

class TacheService {
  getUserReview() {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.get(`${api_url}/statistics/home`, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  getTasksList() {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.get(`${api_url}/taches`, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }
  getMyTasksList() {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.get(`${api_url}/taches/my-tasks`, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  createTask(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.post(`${api_url}/taches`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }
  updateTask(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.put(`${api_url}/taches/${data?.idTache}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }
  deleteTask(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.delete(`${api_url}/taches/${data}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  getTasksRulesList() {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.get(`${api_url}/taches/tache-rules`, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  createTasksRule(data) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.post(`${api_url}/taches/tache-rules`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }

  removeTasksRule(ruleId) {
    let token = storage.getToken();
    let mgToken = storage.getMgToken();
    return axios.delete(`${api_url}/taches/tache-rules/${ruleId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        [mg_token_name]: `${mgToken}`,
      },
    });
  }
}

export default new TacheService();
